"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiLoader = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
function UiLoader({ fill, color, size }) {
    color = color || 'primary';
    size = size || 8;
    const style = {
        height: size,
        width: size,
    };
    if (fill) {
        style.backgroundColor = fill;
    }
    return (react_1.default.createElement("div", { className: clsx_1.default('UiLoader', `color-${color}`) },
        react_1.default.createElement("div", { style: style }),
        react_1.default.createElement("div", { style: style }),
        react_1.default.createElement("div", { style: style })));
}
exports.UiLoader = UiLoader;
